module.exports = __webpack_public_path__ + "static/media/the-freedom-soup.439a8a49.jpg";